export default "__VITE_ASSET__Cmx_VoXd__"